import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "slick-carousel/slick/slick.scss";
import { Button } from "@components/atoms";
import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import ReactSVG from "react-svg";
import * as appPaths from "../../../../app/routes";
import { ShareIcons } from "../../../../components/OverlayManager/ShareProject/ShareIcons";
import thxImage from "../../../../images/checkout-thx.svg";
import downloadImage from "../../../../images/download-rose.svg";
import logoMobile from "../../../../images/logo-mobile.svg";
import logoImg from "../../../../images/logo.svg";
import * as S from "./styles";

/**
 * Thank you page after completing the checkout.
 */
var ThankYou = function ThankYou(_ref) {
  var orderNumber = _ref.orderNumber,
      continueShopping = _ref.continueShopping,
      orderDetails = _ref.orderDetails,
      items = _ref.items,
      shareUrl = _ref.shareUrl;
  var intl = useIntl();
  var sliderSettings = {
    arrows: false,
    // autoplaySpeed: 4000,
    dots: true,
    fade: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 600
  };
  return React.createElement(S.Wrapper, null, React.createElement(S.Logo, null, React.createElement(Link, {
    to: appPaths.baseUrl,
    className: "main-menu__logo main-menu__logo-checkout"
  }, React.createElement("img", {
    src: logoImg,
    alt: "Reno"
  }), React.createElement("img", {
    src: logoMobile,
    alt: "Reno",
    className: "main-menu__logo-mobile"
  }))), React.createElement(S.Left, null, React.createElement(S.ThankYouHeader, null, React.createElement("img", {
    src: thxImage,
    alt: "thank you"
  }), React.createElement("div", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Congratulations!",
    "id": "@next.components.organisms.ThankYou.ThankYou.3185451863"
  }, "id", "@next.components.organisms.ThankYou.ThankYou.3185451863"))), React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "You bought new doors!",
    "id": "@next.components.organisms.ThankYou.ThankYou.4137441800"
  }, "id", "@next.components.organisms.ThankYou.ThankYou.4137441800")))), React.createElement(S.Paragraph, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Share your design with your friends and get their opinion:",
    "id": "@next.components.organisms.ThankYou.ThankYou.2984776068"
  }, "id", "@next.components.organisms.ThankYou.ThankYou.2984776068"))), React.createElement(ShareIcons, {
    url: shareUrl
  }), React.createElement(S.Download, null, React.createElement(Button, null, intl.formatMessage(_defineProperty({
    defaultMessage: "assembly instructions",
    "id": "@next.components.organisms.ThankYou.ThankYou.238257033"
  }, "id", "@next.components.organisms.ThankYou.ThankYou.238257033")), React.createElement(ReactSVG, {
    path: downloadImage
  }))), React.createElement(S.Buttons, null, React.createElement(S.Link, {
    onClick: orderDetails
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "See order details",
    "id": "@next.components.organisms.ThankYou.ThankYou.3128149641"
  }, "id", "@next.components.organisms.ThankYou.ThankYou.3128149641"))), React.createElement(S.Link, {
    onClick: continueShopping,
    color: "secondary"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Back to homepage",
    "id": "@next.components.organisms.ThankYou.ThankYou.3375237564"
  }, "id", "@next.components.organisms.ThankYou.ThankYou.3375237564"))))), React.createElement(S.SliderWrapper, null, React.createElement(Slider, _extends({}, sliderSettings, {
    className: "checkout-slider"
  }), items === null || items === void 0 ? void 0 : items.map(function (item) {
    return React.createElement(S.Slide, {
      key: item.key
    }, React.createElement(S.SliderImage, null, React.createElement("img", {
      src: item.imageUrl,
      alt: ""
    })), React.createElement(S.SliderTitle, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Sliding doors",
      "id": "@next.components.organisms.ThankYou.ThankYou.785029631"
    }, "id", "@next.components.organisms.ThankYou.ThankYou.785029631"))), React.createElement(S.SliderHint, null, item.categoryName));
  }))));
};

export { ThankYou };